import(/* webpackMode: "eager", webpackExports: ["OfertaContent"] */ "/var/www/azia_frontv2_green/src/app/oferta/oferta-content.tsx");
